import React from "react";
import NotFound from "./404";

const NotFoundFolder = ({}) => {
    return (<>
        <NotFound></NotFound>
    </>);
};

export default NotFoundFolder;